module.exports = __webpack_public_path__ + "static/media/cal-diaphragm.b1fed96d.jpg";